import React from 'react';
import { Modal, Fade, Backdrop } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { isMobile } from 'react-device-detect';
import { schemaSignIn } from '../../../utils/validations';
import { Formik } from 'formik';
import SwitcherForm from './SwitcherForm';

const useStyles = makeStyles({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    paper: {
        display: 'flex',
        flexDirection: 'Column',
        width: isMobile ? 328 : 432,
        borderRadius: 4,
        padding: isMobile ? '24px 16px' : 24,
        boxShadow: '0 15px 15px 0 rgba(0, 40, 62, 0.3)',
        backgroundColor: 'white',
        '&:focus': {
            outline: 'none',
        },
    },
    infoWrapper: {
        display: 'flex',
        flexFlow: 'column',
        alignItems: 'flex-start',
    },
    name: {
        fontSize: 22,
        color: '#10587f',
        textAlign: 'left',
        marginBottom: 21,
        fontWeight: 'bold',
    },
    subname: {
        fontSize: 16,
        color: '#484848',
        textAlign: 'left',
        margin: '0 0 34px 0',
    },
})

const SwitcherModal = ({
    open,
    handleClose,
    primaryFunction,
    setSelectedElemInDrop,
    switchTo,
    fromLogin,
}) => {

    const classes = useStyles()

    const initialValues = {
        email: '',
        password: ''
    }

    const closeModal = (event) => {
        event.preventDefault()
        //setSelectedElemInDrop(0)
        handleClose()
    }

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            className={classes.modal}
            open={open}
            onClose={closeModal}
            closeAfterTransition
            BackdropComponent={Backdrop}
            BackdropProps={{
                timeout: 500,
            }}
        >
            <Fade in={open}>
                <div className={classes.paper}>
                    <div className={classes.infoWrapper}>
                        <p className={classes.name}>
                            {switchTo === 'lawfirm' && !fromLogin ? 
                                ('Es necesario ir al perfil del despacho para ver la notificación') 
                                :
                                switchTo === 'lawyer' && !fromLogin ? 
                                ('Es necesario ir al perfil del abogado para ver la notificación') 
                                :
                                ('Estás por cambiar de perfil')
                            }
                        </p>
                    
                        <div className={classes.subname}>
                            <span>
                                {switchTo === 'lawyer' ? 
                                  ('Al cambiar de perfil se cerrará la sesión actual.')
                                 :
                                  ('Al cambiar de perfil se cerrará la sesión actual y es necesario que introduzcas a continuación tus credenciales correspondientes al perfil al que deseas acceder.')
                                }
                            </span>
                        </div>
                    
                        <Formik
                            initialValues={initialValues}
                            validationSchema={ switchTo === 'lawfirm' && schemaSignIn}
                            onSubmit={primaryFunction}
                            render={props => (
                                <SwitcherForm
                                    {...props}
                                    handleClose={closeModal}
                                    hideForm = { switchTo === 'lawyer' }
                                />
                            )}
                        />
                    </div>
                </div>
            </Fade>
        </Modal>
    )
}

export default SwitcherModal;
